// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMeta from 'vue-meta'
import Mint from 'mint-ui'
import axios from 'axios';
Vue.use(VueMeta)
import  './assets/style/base.css';
import 'mint-ui/lib/style.css'
import config from './common/config.js'
import utils from './common/utils.js'
import './utils/global-component'

Vue.use(Mint);
Vue.config.productionTip = false
Vue.prototype.$demoInstance = new GetDemo(config.ENV === 'production' ? 'production' : 'dev');

axios.defaults.withCredentials = true;
axios.defaults.headers.common['CMALL_TOKEN'] = utils.getCookie('CMALL_TOKEN')



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js